import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import AppointmentAction, {
  AppointmentSelectors,
  AppointmentTypes,
} from '../Redux/AppointmentRedux'
import { ItemsPerPage } from '../Redux/genericReducers'

export function* getAll(api, action) {
  let params = {}
  if (action.params.product_uuid) {
    params = { product_uuid: action.params.product_uuid }
  }

  if (action.params.duration_uuid) {
    params = { duration_uuid: action.params.duration_uuid }
  }

  const resp = yield call(api.getAppointments, params)
  if (resp.ok) {
    yield put(AppointmentAction.appointmentsListSuccess(resp.data))
    if (!!action.callback) {
      action.callback()
    }
  } else {
    yield put(AppointmentAction.appointmentsListFailure('something went wrong'))
  }
}

export function* upsertAppointment(api, action) {
  const resp = yield call(api.upsertAppointments, {
    appointments: action.params,
  })
  if (resp.ok) {
    yield put(AppointmentAction.appointmentsUpsertSuccess(resp.data))
    action.callback()
  } else {
    yield put(
      AppointmentAction.appointmentsUpsertFailure('something went wrong')
    )
    action.callback()
  }
}

export function* singleUpsertAppointment(api, action) {
  const resp = yield call(api.singleUpsertAppointments, action.params)
  if (resp.ok) {
    yield put(AppointmentAction.appointmentsSingleUpsertSuccess(resp.data))
    action.callback(action.params.index, action.params.total)
  } else {
    yield put(
      AppointmentAction.appointmentsSingleUpsertFailure('something went wrong')
    )
    action.callback(action.params.index, action.params.total)
  }
}

export function* multipleUpsertAppointment(api, action) {
  const resp = yield call(api.multipleUpsertAppointments, {
    data: action.params,
  })
  if (resp.ok) {
    yield put(AppointmentAction.appointmentsMultipleUpsertSuccess(resp.data))
    action.callback()
  } else {
    yield put(
      AppointmentAction.appointmentsMultipleUpsertFailure(
        'something went wrong'
      )
    )
    action.callback()
  }
}

export function* sendTestEmail(api, action) {
  const resp = yield call(api.sendTestEmail, action.params)
  if (resp.ok) {
    yield put(AppointmentAction.sendTestEmailSuccess())
    action.callback()
  } else {
    yield put(AppointmentAction.sendTestEmailSuccess())
    action.callback()
  }
}

export function* deleteCustomField(api, action) {
  const resp = yield call(api.deleteCustomField, action.apptId, {
    id: action.customFieldId,
  })
  if (resp.ok) {
    yield put(AppointmentAction.customFieldDeleteSuccess())
    action.callback()
  } else {
    yield put(AppointmentAction.customFieldDeleteFailure())
    action.callback()
  }
}

export function* deleteSubscription(api, action) {
  const resp = yield call(api.deleteSubscription, action.apptId)
  if (resp.ok) {
    action.callback()
  } else {
    action.callback()
  }
}

export function* generateBookingLink(api, action) {
  const resp = yield call(api.generateBookingLink, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* createManualSubscription(api, action) {
  const resp = yield call(api.createManualSubscription, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* createManualRecurringSubscription(api, action) {
  const resp = yield call(api.createManualRecurringSubscription, action.params)
  action.callback(resp.data)
}

export function* appointmentsSearchRequest(api, action) {
  const resp = yield call(api.searchAppointments, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* createCustomer(api, action) {
  const resp = yield call(api.createCustomer, action.params)
  if (resp.ok) {
    action.callback(resp.data, '')
  } else {
    action.callback('', 'Unable to create customer. Please ensure the email or phone number is valid and that the customer is not already registered in Shopify.')
  }
}

export function* getCustomerTags(api, action) {
  const resp = yield call(api.getAllCustomerTags)
  if (resp.ok) {
    if (resp.data && resp.data.fixed_tags) {
      action.callback(resp.data.fixed_tags)
    }
  }
}

export function* getAllSubscriptions(api, action) {
  let params = {}
  const resp = yield call(api.getAppointmentSubscriptions, action.params)
  if (resp.ok) {
    yield put(AppointmentAction.appointmentsSubscriptionsListSuccess(resp.data))
  } else {
    yield put(
      AppointmentAction.appointmentsSubscriptionsListFailure(
        'something went wrong'
      )
    )
  }
}

export function* upsertAppointmentSubscription(api, action) {
  const resp = yield call(api.upsertAppointmentSubscription, action.params)
  if (resp.ok) {
    yield put(
      AppointmentAction.appointmentsSubscriptionsUpsertSuccess(resp.data)
    )
    action.callback()
  } else {
    yield put(
      AppointmentAction.appointmentsSubscriptionsUpsertFailure(
        'something went wrong'
      )
    )
    action.callback()
  }
}

export function* getSubscriptionDetails(api, action) {
  const resp = yield call(api.getAppointmentSubscriptionsDetail, action.id)
  if (resp.ok) {
    yield put(
      AppointmentAction.appointmentsSubscriptionsDetailSuccess(resp.data)
    )
  } else {
    yield put(
      AppointmentAction.appointmentsSubscriptionsDetailFailure(
        'something went wrong'
      )
    )
  }
}

export function* deleteAppointmentSubscription(api, action) {
  const resp = yield call(api.deleteAppointmentSubscription, action.id)
  if (resp.ok) {
    action.callback()
  }
}

export function* deleteAppointmentAddOn(api, action) {
  const resp = yield call(api.deleteAppointmentAddOn, action.id)
  if (resp.ok) {
    action.callback()
  }
}

export function* deleteConflict(api, action) {
  const resp = yield call(api.deleteConflict, action.id)
  if (resp.ok) {
    action.callback()
  }
}

export function* deleteCustomQuestions(api, action) {
  const resp = yield call(api.deleteCustomQuestions, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback('something went wrong')
  }
}


export default function* appointmentSagas(api) {
  yield all([
    takeLatest(AppointmentTypes.APPOINTMENTS_LIST_REQUEST, getAll, api),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_UPSERT_REQUEST,
      upsertAppointment,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_SINGLE_UPSERT_REQUEST,
      singleUpsertAppointment,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_MULTIPLE_UPSERT_REQUEST,
      multipleUpsertAppointment,
      api
    ),
    takeLatest(
      AppointmentTypes.CUSTOM_FIELD_DELETE_REQUEST,
      deleteCustomField,
      api
    ),
    takeLatest(
      AppointmentTypes.SUBSCRIPTION_DELETE_REQUEST,
      deleteSubscription,
      api
    ),
    takeLatest(AppointmentTypes.SEND_TEST_EMAIL, sendTestEmail, api),
    takeLatest(
      AppointmentTypes.GENERATE_BOOKING_LINK,
      generateBookingLink,
      api
    ),
    takeLatest(
      AppointmentTypes.CREATE_MANUAL_SUBSCRIPTION,
      createManualSubscription,
      api
    ),
    takeLatest(
      AppointmentTypes.CREATE_MANUAL_RECURRING_SUBSCRIPTION,
      createManualRecurringSubscription,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_SUBSCRIPTIONS_LIST_REQUEST,
      getAllSubscriptions,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_SUBSCRIPTIONS_UPSERT_REQUEST,
      upsertAppointmentSubscription,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_SEARCH_REQUEST,
      appointmentsSearchRequest,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_SUBSCRIPTIONS_DETAIL_REQUEST,
      getSubscriptionDetails,
      api
    ),
    takeLatest(AppointmentTypes.DELETE_CONFLICT, deleteConflict, api),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_SUBSCRIPTIONS_DELETE_REQUEST,
      deleteAppointmentSubscription,
      api
    ),
    takeLatest(
      AppointmentTypes.APPOINTMENTS_ADD_ON_DELETE_REQUEST,
      deleteAppointmentAddOn,
      api
    ),
    takeLatest(AppointmentTypes.CREATE_CUSTOMER, createCustomer, api),
    takeLatest(AppointmentTypes.GET_ALL_CUSTOMER_TAGS, getCustomerTags, api),
    takeLatest(
      AppointmentTypes.DELETE_CUSTOM_QUESTIONS_REQUEST,
      deleteCustomQuestions,
      api
    ),
  ])
}
